import { useState } from 'react';
import styled from 'styled-components';
import { UIData, useUIStore } from '../../../hooks/stores/uiStore';
import { Item } from './Item';
import { StateItem } from './StateViewController';

export const GroupItem = ({ item, columnIndex }: { item: StateItem; columnIndex?: number }) => {
  const [{ isStateViewControllerFullView: isFullView }] = useUIStore<UIData>();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const selectedItem = item.items?.find((groupItem) => groupItem.stateView === item.selectedStateView);

  return (
    <Container
      onMouseLeave={() => setIsDropdownVisible(false)}
      $isHidden={item.isHidden}
      style={{ overflow: isFullView ? 'hidden' : undefined }}
    >
      <ItemsDropdown $isVisible={isDropdownVisible}>
        {item.items?.map((groupItem, groupIndex) => (
          <Item key={`group-${groupIndex}`} item={groupItem} columnIndex={columnIndex} />
        ))}
      </ItemsDropdown>

      <GroupContainer
        style={{
          height: isFullView ? `${(item.items?.length || 1) * 50 + ((item.items?.length || 1) - 1) * 10}px` : '50px',
        }}
      >
        {isFullView ? (
          item.items?.map((groupItem, groupIndex) => (
            <Item key={`group-${groupIndex}`} item={groupItem} columnIndex={columnIndex} />
          ))
        ) : (
          <SelectedItem onMouseEnter={() => setIsDropdownVisible(false)} $isDropdownVisible={isDropdownVisible}>
            {selectedItem ? (
              <Item item={selectedItem} columnIndex={columnIndex} />
            ) : (
              <div style={{ width: '50px', height: '50px' }} />
            )}

            <ExpandDropdownButton className="expandButton" onMouseEnter={() => setIsDropdownVisible(true)}>
              <i className="icon-arrow-right" style={{ rotate: '-90deg', pointerEvents: 'none' }} />
            </ExpandDropdownButton>
          </SelectedItem>
        )}
      </GroupContainer>
    </Container>
  );
};

const Container = styled.div<{ $isHidden?: boolean }>`
  position: relative;

  box-sizing: border-box;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  transition: opacity var(--transition-2);
  ${({ $isHidden }) => $isHidden && 'opacity: 0; pointer-events: none;'}
`;

const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border-radius: 10px;

  transition: height var(--transition-2);
`;

const ExpandDropdownButton = styled.div`
  position: absolute;
  top: -10px;
  width: 100%;
  height: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  color: var(--neutral-3);
`;

const ItemsDropdown = styled.div<{ $isVisible?: boolean }>`
  position: absolute;
  top: -5px;
  translate: 0 -100%;
  padding: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  border-radius: var(--radius-1);
  border-bottom: none;

  opacity: 0;
  pointer-events: none;
  transition: opacity var(--transition-2);
  ${({ $isVisible: $isExtended }) =>
    $isExtended &&
    `
    opacity: 0.3;
    pointer-events: auto;
    &:hover {
      opacity: 1;
    }
  `}

  backdrop-filter: blur(2px);
`;

const SelectedItem = styled.div<{ $isDropdownVisible?: boolean }>`
  position: relative;

  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: center;

  .expandButton {
    transition:
      translate var(--transition-2),
      color var(--transition-2);
  }

  &:hover {
    .expandButton {
      transition: translate var(--transition-2);
      translate: 0 -5px;
    }
  }

  ${({ $isDropdownVisible }) =>
    $isDropdownVisible &&
    `
  .expandButton {
      translate: 0 -5px;
      color: var(--main-2);
    }
  `};

  &:after {
    content: '';
    pointer-events: none;
    position: absolute;

    width: 60px;
    height: 60px;
    border: 1px solid var(--neutral-3);
    border-radius: var(--radius-1);

    z-index: -1;
    backdrop-filter: blur(2px);
  }
`;
